"use client";

import FAQSection from "@/components/FAQSection/FAQSection";
import DesignTailoredSection from "../UiUxService/DesignTailoredSection/DesignTailoredSection";
import ProductDesignSection from "../UiUxService/ProductDesignSection/ProductDesignSection";
import UiUxCTASection from "../UiUxService/UiUxCTASection/UiUxCTASection";
import UiUxHeroSection from "../UiUxService/UiUxHeroSection/UiUxHeroSection";
import UiUxImpactSection from "../UiUxService/UiUxImpactSection/UiUxImpactSection";
import WhyChooseSection from "../UiUxService/WhyChooseSection/WhyChooseSection";
import UiUxContactSection from "../UiUxService/UiUxContactSection/UiUxContactSection";
import StructuredDesignSection from "../UiUxService/StructuredDesignSection/StructuredDesignSection";
import UiUxTestimonialSection from "../UiUxService/UiUxTestimonialSection/UiUxTestimonialSection";

const UiUxServiceLayout = ({ data }) => {
  return (
    <>
      <UiUxHeroSection hero={data.hero} />
      <ProductDesignSection product={data.product} />
      <WhyChooseSection whyChoose={data.whyChoose} />
       <StructuredDesignSection structuredDesignData = {data.structuredDesignData} />
      <UiUxCTASection cta={data.cta} />
      <UiUxImpactSection impact={data.impact} />
      <DesignTailoredSection design={data.design} />
      <UiUxTestimonialSection />
      <FAQSection title={data.faq.title} faqData={data.faq.items} />
      <UiUxContactSection contact={data.contact} />
    </>
  );
};

export default UiUxServiceLayout;
